<div class="card w-full h-full flex flex-col shadow-sm p-8 rounded-2xl bg-white gap-8">

  <div class="flex flex-row flex-wrap justify-between items-center gap-4">
    <div class="flex flex-col">
      <h1 class="font-semibold text-2xl">
        Ítems
      </h1>
    </div>
    <div class="flex flex-row flex-wrap gap-3">
      <app-button
        label="Descargar plantilla"
        icon="fi-rr-download"
        [disabled]="!itemList.length"
        (clickButton)="downloadTemplate()">
      </app-button>
      <app-button
        label="Cargar Excel"
        icon="fi-rr-upload"
        color="green-500"
        (clickButton)="itemFileInput.click()">
      </app-button>
      <input
        #itemFileInput
        type="file"
        accept=".xlsx"
        class="hidden"
        (change)="onItemFileSelected($event, itemFileInput)">
      @if (massiveLoadErrors.length > 0) {
        <app-button
          [label]="'Ver errores (' + totalMassiveLoadErrors + ')'"
          icon="fi-rr-exclamation"
          color="red-500"
          (clickButton)="showMassiveLoadErrors = !showMassiveLoadErrors">
        </app-button>
      }
    </div>
  </div>

  <div class="flex flex-row flex-wrap justify-start gap-4">
    <app-custom-input
      [(value)]="itemDescription"
      placeholder="Buscar ítems..."
      (enter)="findAll()">
    </app-custom-input>

    <app-button label="Buscar" (click)="findAll()"></app-button>
    <app-button
      label="Limpiar filtros"
      color="red-500"
      icon="fi-rr-eraser"
      (click)="cleanFilter()">
    </app-button>
  </div>

  @if (showMassiveLoadErrors && massiveLoadErrors.length > 0) {
    <app-massive-load-errors
      [errors]="massiveLoadErrors"
      [totalErrors]="totalMassiveLoadErrors"
      entityType="ITEM">
    </app-massive-load-errors>
  }

  <div class="overflow-x-auto">

    @if (itemList && itemList.length > 0) {
      <div class="card">

        <p-table
          [value]="itemList"
          [paginator]="true"
          [rows]="rows"
          [first]="first"
          [lazy]="true"
          [lazyLoadOnInit]="false"
          (onLazyLoad)="loadItems($event)"
          [totalRecords]="totalItems"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
          scrollable="true"
          scrollDirection="horizontal">

          <ng-template #header>
            <tr>

              <th class="px-4 py-2 text-left font-semibold text-base">
                Código
              </th>

              <th class="px-4 py-2 text-left font-semibold text-base">
                Categoría
              </th>

              <th class="px-4 py-2 text-left font-semibold text-base">
                Tipo de producto
              </th>

              <th class="px-4 py-2 text-left font-semibold text-base">
                Acabado
              </th>

              <th class="px-4 py-2 text-left font-semibold text-base w-56">
                Descripción
              </th>

              <th pSortableColumn="dimensions"
                  class="px-4 py-2 text-left font-semibold text-base">
                <div class="flex items-center gap-2">
                  Dimensiones
                  <p-sortIcon field="dimensions" />
                </div>
              </th>

              <th pSortableColumn="color"
                  class="px-4 py-2 text-left font-semibold text-base">
                <div class="flex items-center gap-2">
                  Color
                  <p-sortIcon field="color" />
                </div>
              </th>

              <th pSortableColumn="texture"
                  class="px-4 py-2 text-left font-semibold text-base">
                <div class="flex items-center gap-2">
                  Textura
                  <p-sortIcon field="texture" />
                </div>
              </th>

              <th pSortableColumn="thickness"
                  class="px-4 py-2 text-left font-semibold text-base">
                <div class="flex items-center gap-2">
                  Espesor
                  <p-sortIcon field="thickness" />
                </div>
              </th>

              <th pSortableColumn="faceOne"
                  class="px-4 py-2 text-left font-semibold text-base text-center">
                <div class="flex items-center justify-center gap-2">
                  1 Cara
                  <p-sortIcon field="faceOne" />
                </div>
              </th>

              <th pSortableColumn="faceTwo"
                  class="px-4 py-2 text-left font-semibold text-base text-center">
                <div class="flex items-center justify-center gap-2">
                  2 Caras
                  <p-sortIcon field="faceTwo" />
                </div>
              </th>

              <th pSortableColumn="platform"
                  class="px-4 py-2 text-left font-semibold text-base text-center w-16">
                <div class="flex items-center justify-center gap-2">
                  Tarima
                  <p-sortIcon field="platform" />
                </div>
              </th>

              <th pSortableColumn="halfPlatform"
                  class="px-4 py-2 text-left font-semibold text-base text-center w-16">
                <div class="flex items-center justify-center gap-2">
                  1/2
                  <p-sortIcon field="halfPlatform" />
                </div>
              </th>

              <th pSortableColumn="quarterPlatform"
                  class="px-4 py-2 text-left font-semibold text-base text-center w-16">
                <div class="flex items-center justify-center gap-2">
                  1/4
                  <p-sortIcon field="quarterPlatform" />
                </div>
              </th>

              <th pSortableColumn="eighthPlatform"
                  class="px-4 py-2 text-left font-semibold text-base text-center w-16 hidden xl:table-cell">
                <div class="flex items-center justify-center gap-2">
                  Mínima
                  <p-sortIcon field="eighthPlatform" />
                </div>
              </th>


              <th pSortableColumn="leadTime"
                  class="px-4 py-2 text-left font-semibold text-base text-center w-16 hidden xl:table-cell">
                <div class="flex items-center justify-center gap-2">
                  Días de entrega
                  <p-sortIcon field="leadTime" />
                </div>
              </th>

              <th pSortableColumn="active"
                  class="px-4 py-2 text-left font-semibold text-base text-center">
                <div class="flex items-center justify-center gap-2">
                  Activo
                  <p-sortIcon field="active" />
                </div>
              </th>

              <th class="px-4 py-2 text-left font-semibold text-base text-center">
                Acción
              </th>

            </tr>
          </ng-template>

          <ng-template #body let-itemList>
            <tr class="hover:bg-orange-50">

              <td class="px-6 py-4">{{ itemList.id }}</td>
              <td class="px-6 py-4">{{ itemList.product.category }}</td>
              <td class="px-6 py-4">{{ itemList.product.productType }}</td>
              <td class="px-6 py-4">{{ itemList.product.finish }}</td>

              <td class="px-6 py-4 truncate max-w-56"
                  title="{{ itemList.description }}">
                {{ itemList.description }}
              </td>

              <td class="px-6 py-4">{{ itemList.dimensions }}</td>
              <td class="px-6 py-4">{{ itemList.color?.name }}</td>
              <td class="px-6 py-4">{{ itemList.texture }}</td>
              <td class="px-6 py-4">{{ itemList.thickness }} mm</td>

              <td class="px-6 py-4 text-center">{{ itemList.faceOne }}</td>
              <td class="px-6 py-4 text-center">{{ itemList.faceTwo }}</td>
              <td class="px-6 py-4 text-center">{{ itemList.platform }}</td>
              <td class="px-6 py-4 text-center">{{ itemList.halfPlatform }}</td>
              <td class="px-6 py-4 text-center">{{ itemList.quarterPlatform }}</td>
              <td class="px-6 py-4 text-center hidden xl:table-cell">
                {{ itemList.eighthPlatform }}
              </td>
              <td class="px-6 py-4 text-center">{{ itemList.leadTime }}</td>

              <td class="px-6 py-4 text-center">
                <span
                  class="inline-flex px-3 py-1 text-xs font-medium rounded-xl"
                  [ngClass]="getBackgroundClasses(itemList.active)">
                  {{ itemList.active }}
                </span>
              </td>

              <td class="px-6 py-4">
                <div class="text-gray-400 flex flex-row gap-1 justify-center">

                  <i class="fi fi-rr-pencil flex text-2xl text-blue-300 cursor-pointer hover:text-blue-700"
                    title="Editar" (click)="openEditModal(itemList.id)"></i>

                  @if (itemList.active) {
                    <i class="fi fi-rr-toggle-on flex text-2xl text-green-500 cursor-pointer hover:text-green-700"
                      title="Desactivar" 
                      (click)="openActivateItemModal(itemList.description, itemList.id)">
                    </i>
                  } @else {
                    <i class="fi fi-rr-toggle-off flex text-2xl text-gray-400 cursor-pointer hover:text-gray-600"
                      title="Activar" 
                      (click)="openActivateItemModal(itemList.description, itemList.id, true)">
                    </i>
                  }

                  <i class="fi fi-rs-layer-plus text-2xl text-green-700 cursor-pointer hover:text-green-900"
                    title="Agregar relación"
                    (click)="openAddRelationsModal(itemList, itemList.id)">
                  </i>
                </div>
              </td>

            </tr>
          </ng-template>

        </p-table>
      </div>
    } @else {
      <div class="bg-yellow-100 p-4 rounded-2xl">
        No hay registros
      </div>
    }

  </div>
</div>
